import "styles/reset.css"
import "styles/index.scss"
import "assets/fonts/iconfont.css"
import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
